<template>
  <div class="page-content loginPage">
    <div class="login-title">
      <div class="login-title-content">登录后更便捷</div>
    </div>
    <div>
      <div class="login-phone loginCon">
        <div class="item-content mt10">
          <div class="item-inner">
            <div
              class="item-input-title"
              id="callingCodeContent"
              ref="callingCodeContent"
              style="width: auto"
            >
              <div class="callingCode">
                {{
                  `${selectedCallingCode.countryName}(${selectedCallingCode.callingCode})`
                }}
              </div>
              <select
                class="callingCode-css callingCode-js"
                @change="onCallingCodeChange($event)"
              >
                <option
                  v-for="(code, i) in callingCodes"
                  :key="i"
                  :value="code.callingCode"
                >
                  {{ `${code.countryName}(${code.callingCode})` }}
                </option>
              </select>
            </div>
            <div class="item-input">
              <input
                id="phone"
                type="text"
                pattern="[0-9]*"
                :style="telephoneStyle"
                name="Telephone"
                maxlength="11"
                placeholder="请输入手机号"
                @change="onMobileChange($event)"
              />
            </div>
          </div>
        </div>

        <div class="item-content mt10">
          <div class="item-inner">
            <span class="item-input-title">短信验证码</span>
            <div class="item-input">
              <input
                id="validateCode"
                type="text"
                pattern="[0-9]*"
                name="VerifyCode"
                @change="smsCode = $event.target.value"
              />
            </div>
          </div>
          <div
            class="send_btn"
            :class="{ disabled: smsCodeCountDown > 0 }"
            id="sendCode"
            @click="onSmsClick"
            v-show="smsCodeCountDown <= 0"
          >
            {{ getSendSmsCodeText() }}
          </div>
          <div
            class="send_btn"
            :class="{ disabled: smsCodeCountDown > 0 }"
            v-if="smsCodeCountDown >0"
          >
            {{ getSendSmsCodeText() }}
          </div>
        </div>
        <div
            class="item-content recommendedCode-js mt10"
            v-show="showMarketingFlagEmail"
        >
          <div class="item-inner">
            <span class="item-input-title">邮箱(建议)</span>
            <div class="item-input">
              <input
                  id="marketingEmailInput"
                  type="text"
                  name="MarketingEmailInput"
                  @change="marketingEmailInput = $event.target.value"
              />
            </div>
          </div>
        </div>
        <div
          class="item-content recommendedCode-js mt10"
          v-show="!isRegisteredReward"
        >
          <div class="item-inner">
            <span class="item-input-title">好友推荐码(选填)</span>
            <div class="item-input">
              <input
                id="recommendedCode"
                type="text"
                name="RecommendedCode"
                @change="recommendedCode = $event.target.value"
              />
            </div>
          </div>
        </div>
        <div
          class="content-block external loginButton mt10"
          id="loginPhoneSubmit"
          @click="onLoginClick"
        >
          立即登录/注册
        </div>
        <template v-if="!isTrade">
          <div class="sin_container mt15" v-show="!isRegistered && isShowReward">
            <div class="input__top isAgreePrivacy"
                 :class="{ active: isCheckAll }"
                 @click="handleCheckAll">
              <img src="https://resource.rcclchina.com.cn/tui2/user_center/item-selected-new.png"/>
              <img src="https://resource.rcclchina.com.cn/tui2/user_center/item-unselected2-new.png"/>
              <span>全部</span>
            </div>
          </div>
          <div class="login-vip mt10"
               v-show="isRegistered && !isRegisteredReward && isShowReward">
            <div class="vip-title">加入会员尊享</div>
            <ul class="vip-content">
              <li>获得积分兑换精美礼品</li>
              <li>提前获取订票优惠及品牌资讯</li>
              <li>尊享更多会员线上线下活动通知</li>
            </ul>
          </div>
          <div class="sin_container mt10"
               v-show="(!isRegistered || !isRegisteredReward) && isShowReward">
            <div
                class="input__top isAgreePrivacy"
                :class="{ active: wantToRegisterReward }"
                @click="handleCheckItem('wantToRegisterReward')">
              <img src="https://resource.rcclchina.com.cn/tui2/user_center/item-selected-new.png"/>
              <img src="https://resource.rcclchina.com.cn/tui2/user_center/item-unselected2-new.png"/>
              <span>我同意注册“皇家游享荟”会员（限中国大陆地区手机号），并接收品牌资讯及优惠信息，详见<router-link
                  target="_blank"
                  class="memberLink external"
                  style="text-decoration: underline"
                  to="/Rccl.UserCenter/RewardRule"
              >《项目细则》</router-link>
              </span>
            </div>
          </div>
          <div class="sin_container mt10" v-show="!isRegistered">
            <div class="input__top isAgreePrivacy"
                 :class="{ active: wantToAgreePrivacy }"
                 @click="handleCheckItem('wantToAgreePrivacy')">
              <img src="https://resource.rcclchina.com.cn/tui2/user_center/item-selected-new.png"/>
              <img src="https://resource.rcclchina.com.cn/tui2/user_center/item-unselected2-new.png"/>
              <span>我已阅读并同意
                <router-link
                  target="_blank"
                  class="privacyLink external"
                  style="text-decoration: underline"
                  to="/Rccl.UserCenter/Privacy"
                  >《隐私政策》</router-link
                ><router-link
                    target="_blank"
                    class="privacyLink external"
                    style="text-decoration: underline"
                    to="/wz_index_law/index"
                >《用户协议》</router-link>
              </span>
            </div>
          </div>
          <div class="sin_container mt10"
               v-show="isRegisteredReward && !isAgreeEmail  && isShowReward">
            <div
                class="input__top isAgreePrivacy"
                :class="{ active: wantToAgreeEmail }"
                @click="handleCheckItem('wantToAgreeEmail')">
              <img src="https://resource.rcclchina.com.cn/tui2/user_center/item-selected-new.png"/>
              <img src="https://resource.rcclchina.com.cn/tui2/user_center/item-unselected2-new.png"/>
              <span>我想提前获取优惠信息，且同意接收皇家加勒比国际游轮品牌资讯</span>
            </div>
          </div>
                <!--        <div class="sin_container mt10" v-show="!isRegisteredReward">-->
<!--          <div v-show="isShowReward"-->
<!--            class="input__top isRegisterMember"-->
<!--            :class="{ active: wantToRegisterReward }"-->
<!--            @click="handleCheckItem('wantToRegisterReward')"-->
<!--          >-->
<!--            <img-->
<!--              src="https://resource.rcclchina.com.cn/tui2/user_center/item-selected-new.png"-->
<!--            />-->
<!--            <img-->
<!--              src="https://resource.rcclchina.com.cn/tui2/user_center/item-unselected2-new.png"-->
<!--            />-->
<!--            <span-->
<!--              >我已阅读-->
<!--              <router-link-->
<!--                target="_blank"-->
<!--                class="memberLink external"-->
<!--                style="text-decoration: underline"-->
<!--                to="/content/rewardprivacy"-->
<!--                >《“皇家游享荟”项目细则》</router-link-->
<!--              >-->
<!--              并同意注册“皇家游享荟”会员及接受会员相关的优惠资讯及推送消息</span-->
<!--            >-->
<!--          </div>-->

<!--          <div -->
<!--            class="input__top isAgreePushMsg"-->
<!--            :class="{ active: wantToAgreeEmail }"-->
<!--            v-show="!isAgreeEmail && !isRegisteredReward && (isShowReward || isShowHongKong)"-->
<!--            @click="handleCheckItem('wantToAgreeEmail')"-->
<!--          >-->
<!--            <img-->
<!--              src="https://resource.rcclchina.com.cn/tui2/user_center/item-selected-new.png"-->
<!--            />-->
<!--            <img-->
<!--              src="https://resource.rcclchina.com.cn/tui2/user_center/item-unselected2-new.png"-->
<!--            />-->
<!--            <span>-->
<!--              我同意接受皇家加勒比游轮（中国）有限公司及其关联公司的优惠资讯及推送消息-->
<!--            </span>-->
<!--          </div>-->
<!--        </div>-->
        </template>
        <template v-else>
          <!--旅行社Trade-->
          <div class="sin_container mt15" v-show="!isRegistered && !isAgreeEmail">
            <div class="input__top isAgreePrivacy"
                 :class="{ active: isCheckAll }"
                 @click="handleCheckAllTrade">
              <img src="https://resource.rcclchina.com.cn/tui2/user_center/item-selected-new.png"/>
              <img src="https://resource.rcclchina.com.cn/tui2/user_center/item-unselected2-new.png"/>
              <span>全部</span>
            </div>
          </div>
          <div class="sin_container mt10"
               v-show="!isAgreeEmail">
            <div
                class="input__top isAgreePrivacy"
                :class="{ active: wantToAgreeEmail }"
                @click="handleCheckItem('wantToAgreeEmail')">
              <img src="https://resource.rcclchina.com.cn/tui2/user_center/item-selected-new.png"/>
              <img src="https://resource.rcclchina.com.cn/tui2/user_center/item-unselected2-new.png"/>
              <span>我同意获取皇家加勒比游轮船务(中国)有限公司及其关联公司的优惠资讯。</span>
            </div>
          </div>
          <div class="sin_container mt10" v-show="!isRegistered && !isAgreeEmail">
            <div class="input__top isAgreePrivacy"
                 :class="{ active: wantToAgreePrivacy }"
                 @click="handleCheckItem('wantToAgreePrivacy')">
              <img src="https://resource.rcclchina.com.cn/tui2/user_center/item-selected-new.png"/>
              <img src="https://resource.rcclchina.com.cn/tui2/user_center/item-unselected2-new.png"/>
              <span>我已阅读并同意
                <router-link
                    target="_blank"
                    class="privacyLink external"
                    style="text-decoration: underline"
                    to="/Rccl.UserCenter/Privacy"
                >《隐私政策》</router-link
                ><router-link
                    target="_blank"
                    class="privacyLink external"
                    style="text-decoration: underline"
                    to="/wz_index_law/index"
                >《用户协议》</router-link>
              </span>
            </div>
          </div>
        </template>
        <div class="sin_container mt10" v-show="showMarketingFlagEmail">
          <div
              class="input__top isAgreePrivacy"
              :class="{ active: marketingFlagEmail }"
              @click="handleCheckItem('marketingFlagEmail')">
            <img src="https://resource.rcclchina.com.cn/tui2/user_center/item-selected-new.png"/>
            <img src="https://resource.rcclchina.com.cn/tui2/user_center/item-unselected2-new.png"/>
            <span>我同意电子邮箱接受皇家加勒比品牌资讯及优惠信息</span>
          </div>
        </div>
        <div class="login-title-tips">
          如之前未使用手机注册过，则会自动为您创建新用户账号，方便您之后直接登录
        </div>
      </div>
    </div>
    <div class="verification-popup" v-show="isShowVerification">
      <div class="verification-bg"></div>
      <div class="verification-content">
        <div class="verification-title">
          安全验证
        </div>
        <div class="verification-main" id="verificationMain">

        </div>
      </div>
    </div>
    <div id="captchaElement"></div>
    <button id="captchaTrigger" type="button" style="display:none"></button>
  </div>
</template>

<script>
import api from "@/api";
import { gioTracking, isEmpty } from "@/utilities/tools";
const SCENE_ID = '5v4v21th';
export default {
  name: "Login",
  data() {
    return {
      callingCodes: [],
      isRegistered: true,
      isRegisteredReward: true,
      isAgreeEmail: true,
      selectedCallingCode: {
        callingCode: "+86",
        countryName: "中国",
      },
      telephoneLeft: 95,
      mobile: "",
      smsCode: "",
      smsCodeCountDown: 0,
      recommendedCode: "",
      isShowReward: true,
      wantToRegisterReward: false,
      wantToAgreeEmail: false,
      wantToAgreePrivacy: false,
			isAllowLogin: true,
      afsType: "AliYunAfsNvc",
      isShowVerification: false,
      isCheckAll: false,
      isTrade: false,
      captcha: null,
      loading: false,
      captchaVerifyParamLogin:'',
      captchaBizType: null,  // 当前业务验证类型：login | sms
      showMarketingFlagEmail: false,
      marketingFlagEmail: false,
      originalMarketingFlagEmail: false,
      marketingEmailInput: ""
    };
  },
  async beforeMount() {
    if(this.$route.query?.viewSource) {
      this.isTrade = this.$route.query?.viewSource === 'pcpTrade';
      this.$store.dispatch("SET_VIEW_SOURCE", this.$route.query.viewSource);
    } else {
      this.isTrade = this.viewSource && this.viewSource === 'pcpTrade';
    }
    console.log(this.viewSource)
    if(this.$route.query.gtsoffline === '1') {
      window.location.href="weixin://dl/business/?t=yLXsks7xtEl";
      return;
    }
    this.$store.commit("SET_PAGE_TITLE", "登录 / 注册");
    const { success, data, errMsg } = await api.page.getCallingCode();
    if (!success) console.error(errMsg);
    this.callingCodes = data;
  },
  mounted() {
    this.initCaptcha();
  },
  methods: {
    handleCheckAll() {
      if(this.isRegisteredReward && !this.isAgreeEmail && this.isShowReward) {
        this.wantToAgreePrivacy = this.wantToAgreeEmail = this.marketingFlagEmail = this.isCheckAll =! this.isCheckAll;
      } else {
        this.wantToAgreePrivacy = this.wantToRegisterReward = this.marketingFlagEmail = this.isCheckAll =! this.isCheckAll;
      }
    },
    //旅行社
    handleCheckAllTrade() {
      this.wantToAgreePrivacy = this.wantToAgreeEmail = this.marketingFlagEmail = this.isCheckAll =! this.isCheckAll;
    },
    handleCheckItem (val) {
      switch (val) {
        case "wantToAgreePrivacy":
          this.wantToAgreePrivacy =! this.wantToAgreePrivacy;
          break;
        case "wantToRegisterReward":
          this.wantToRegisterReward =! this.wantToRegisterReward;
          break;
        case "wantToAgreeEmail":
          this.wantToAgreeEmail =! this.wantToAgreeEmail;
          break;
        case "marketingFlagEmail":
          this.marketingFlagEmail =! this.marketingFlagEmail;
          break;
      }
      if(!this.isTrade) {
        if (this.isRegisteredReward && !this.isAgreeEmail && this.isShowReward) {
          this.isCheckAll = this.wantToAgreePrivacy && this.wantToAgreeEmail && this.marketingFlagEmail;
        } else {
          this.isCheckAll = this.wantToAgreePrivacy && this.wantToRegisterReward && this.marketingFlagEmail;
        }
      } else {
        this.isCheckAll = this.wantToAgreePrivacy && this.wantToAgreeEmail && this.marketingFlagEmail;
      }
    },
    onCallingCodeChange(e) {
      const value = e.target.value;
      const callingCode = this.callingCodes.filter(
        (r) => r.callingCode == value
      );
      if (callingCode && callingCode.length > 0) {
        this.selectedCallingCode = callingCode[0];
      }
      this.isShowReward = (value === "+86" || value === "86") || (value === "+852" || value === "852") || (value === "+853" || value === "853")
      this.wantToRegisterReward = this.wantToAgreeEmail = this.wantToAgreePrivacy = this.isCheckAll = false;
      this.checkIsRegister(this.mobile)
      setTimeout(() => {
        this.telephoneLeft = this.$refs.callingCodeContent.clientWidth + 18;
      }, 100);


    },
    onMobileChange(e) {
      const mobile = e.target.value;
      this.mobile = mobile;
      this.checkIsRegister(mobile);
    },
    async checkIsRegister(mobile) {
      if (mobile == null || mobile.length == 0) return
      const { success, data, errMsg } = await api.user.checkHasRegister(
        mobile,
        this.selectedCallingCode.callingCode
      );
      if (!success) console.error(errMsg);
      this.isRegistered = data.hasRegisterUser;
      this.isRegisteredReward = data.hasRegisterReward;
      // this.isAgreeEmail = data.hasAgreeEmail;
      this.isAgreeEmail = data.receiveMarketingFlag;
      this.originalMarketingFlagEmail = data.marketingFlagEmail;
      this.showMarketingFlagEmail = !data.marketingFlagEmail;
    },
    // 点击登录
    onLoginClick() {
      /* 先进行验证，再访问接口 */
      if (!this.isRegistered && !this.wantToAgreePrivacy) {
        this.$alert.show("请勾选隐私政策");
        return;
      }

      if (this.mobile == null || this.mobile.length == 0) {
        this.$alert.show("请输入手机号");
        return;
      } else if (this.smsCode == "") {
        this.$alert.show("请输入短信验证码");
        return;
      }

      if(this.originalMarketingFlagEmail === false) {
        if(this.marketingFlagEmail) {
          if(isEmpty(this.marketingEmailInput)) {
            this.$alert.show("请输入您的邮箱");
            return;
          } else {
            const emailRx = /^[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?$/;
            console.log('emailRx.test(marketingEmailInput)', emailRx.test(this.marketingEmailInput))
            if(!emailRx.test(this.marketingEmailInput)) {
              this.$alert.show("请输入正确的邮箱");
              return;
            }
          }
        } else {
          if(!isEmpty(this.marketingEmailInput)) {
            this.$alert.show("请勾选同意电子邮箱<br/>接受皇家加勒比品牌资讯及优惠信息");
            return;
          }
        }
      }

      if (this.loading) return
      this.captchaBizType = 'login'
      this.loading = true
      document.getElementById('captchaTrigger').click()
    },
    onSmsClick() {
      if (this.loading) return
      this.captchaBizType = 'sms'
      this.loading = true
      document.getElementById('captchaTrigger').click()
    },

    onCaptchaSuccess(captchaRes) {
      const biz = this.captchaBizType
      // 刷新
      this.captcha && this.captcha.refresh();
      
      this.$loading.hide();
      if (biz === 'login') {
        this.captchaSuccessLogin(captchaRes)
      } else if (biz === 'sms') {
        this.captchaSuccessSms(captchaRes)
      }
    },
    captchaFail() {
      this.loading = false
      this.captchaBizType = null
      this.isAllowLogin = false
    },

    async captchaSuccessSms(captchaVerifyParam) {
      try {
        this.isAllowLogin = true;
        this.$loading.show();
        const request = this.getSmsRequest("AliYunAfsNc", captchaVerifyParam);
        await this.sendSmsApi(request);
      } finally {
        this.resetCaptcha()
      }
    },
    async captchaSuccessLogin(captchaVerifyParam) {
      try {
        this.isAllowLogin = true;
        this.captchaVerifyParamLogin = captchaVerifyParam
        await this.login();
      } finally {
        this.resetCaptcha()
      }
    },

    resetCaptcha() {
      if (this.captcha && typeof this.captcha.refresh === 'function') {
        this.captcha.refresh()
      }
      this.captchaBizType = null
      this.loading = false
      this.isAllowLogin = false
    },
    
    // 验证码初始化
    initCaptcha () {
			if (!window.initAliyunCaptcha) return
      window.initAliyunCaptcha({
        SceneId: SCENE_ID,
        // 验证码模式，popup表示弹出式，embed表示嵌入式。无需修改
        mode: "popup",
        // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        element: "#captchaElement",
        // 触发验证码弹窗或无痕验证的元素
        button: '#captchaTrigger',
        // 滑块验证和一点即过的验证形态触发框体样式，支持自定义宽度和高度，单位为px。兼容历史参数名。
        slideStyle: {
          width: 360,
          height: 40,
        },
        // 验证码验证通过回调函数
        success: this.onCaptchaSuccess,
        // 验证码验证不通过回调函数
        fail: this.captchaFail,
        // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
        getInstance: (instance) => {
          this.captcha = instance
        }
      });
		},
    async sendSmsCode() {
      if (this.smsCodeCountDown > 0 || !this.isAllowLogin) {
        return;
      }

			// 人机验证
      if (!window.nvc) return;
			this.$loading.show();
      window.nvc.getNVCValAsync(async (nvcVal) => {
				// 无痕验证获取nvc data，用无痕验证模式调用发送短信接口
				const request = this.getSmsRequest("AliYunAfsNvc", nvcVal);
				await this.sendSmsApi(request);
			});
    },
		getSmsRequest (codeType, codeValue) {
			let callingCode = this.selectedCallingCode.callingCode;
      if (
        callingCode &&
        callingCode.length > 1 &&
        callingCode.indexOf("+") == 0
      ) {
        callingCode = callingCode.substring(1);
      }
			const request = {
        phone: this.mobile,
        callingCode: callingCode,
        sessionKey: this.sessionKey,
				codeType: codeType,
				codeValue: codeValue,
        isPc:false,
        sceneId: SCENE_ID,
				captchaVerifyParam: codeValue,
      };
			return request;
		},
		// 无痕验证模式发送短信失败处理方法
		afsFailureHandler(code) {
			// 行为可疑，进入二次滑动验证
			if (code == 'NvcNc') {
				const ncoption = {
					renderTo: "#verificationMain",
				}
				let childNodes = document.getElementById('verificationMain').childNodes;
				for (let i = 0; i < childNodes.length; i++) {
					let childNode = childNodes[i];
					childNode.parentElement.removeChild(childNode);
				}
				// 唤醒二次验证（滑动验证码）
				this.isShowVerification = true;
        this.$nextTick(()=> {
          window.nvc.getNC(ncoption);
        })
			} else if (code == 'Block') {
				// 返回block，禁止发送短信
				this.isAllowLogin = false
				this.$alert.show(
          "网络错误，请刷新页面重试。"
        );
			}
		},
    async sendSmsApi(request) {
			if (!this.isAllowLogin) return;
      const { success, data, errMsg } = await api.user.smsCodeLogin(request);
      this.$loading.hide();
      if (!success) {
        console.error(errMsg);
				if (errMsg == 'NvcNc' || errMsg == 'Block') {
					// this.afsFailureHandler(errMsg)
				} else {
					this.$alert.show(errMsg);
				}
        return;
      } else {
				if (data && data.sessionKey) {
					this.$store.commit("SET_SESSION_KEY", data.sessionKey);
				}
        this.isShowVerification = false;
        this.$alert.show(
          "短信发送成功！若您没有收到短信验证，请一分钟后重新发送。"
        );
      }
      this.smsCodeCountDown = 60;
      const self = this;
      let countDown = setInterval(() => {
        if (self.smsCodeCountDown == 0) {
          clearInterval(countDown);
        } else {
          self.smsCodeCountDown--;
        }
      }, 1000);
    },
    async login() {
      let callingCode = this.selectedCallingCode.callingCode;
      if (
        callingCode &&
        callingCode.length > 1 &&
        callingCode.indexOf("+") == 0
      ) {
        callingCode = callingCode.substring(1);
      }

      let isAgreeEmail,isRegisterMember;
      if(!this.isTrade) {
        if (this.isRegisteredReward && !this.isAgreeEmail && this.isShowReward) {
          isAgreeEmail = isRegisterMember = this.wantToAgreeEmail && this.isShowReward;
        } else {
          isAgreeEmail = isRegisterMember = this.wantToRegisterReward && this.isShowReward;
        }
      } else {
        isAgreeEmail = this.wantToAgreeEmail;
        isRegisterMember = false;
      }

      let params = {
        mobile: this.mobile,
        smsCode: this.smsCode,
        callingCode: callingCode,
        sessionKey: this.sessionKey,
        recommendedCode: this.recommendedCode,
        source: "mobile",
        isAgreeEmail: isAgreeEmail,
        isRegisterMember: isRegisterMember,
        openId: this.$store.state.user.wechatOpenId,
        isCheckPrivacy: this.wantToAgreePrivacy,
        sceneId: SCENE_ID,
        captchaVerifyParam: this.captchaVerifyParamLogin,
      }
      // 未接受过邮件
      if(this.originalMarketingFlagEmail === false) {
        params =  Object.assign(params, {
          marketingFlagEmail: this.marketingFlagEmail,
          marketingEmail: this.marketingEmailInput
        })
      }

      this.$loading.show();
      const { success, data, errMsg } = await api.user.login(params);
      if (!success) {
        console.error(errMsg);
        this.$alert.show(errMsg);
      } else if (data && data.accessToken) {
        this.$store.dispatch("SET_USER_TOKEN", data.accessToken);
        this.loginSuccessHandler(data);
      }
      this.$loading.hide();
    },
    loginSuccessHandler(response) {
      try {
        let hmsrTxt = this.$store.state.page.trackingCode.hmsr + "";
        if (hmsrTxt == "") {
          hmsrTxt = "不适用";
        }

        let marketable = "";
        const isNewUser = response.isNewUser ? "1" : "0";
        const isNewLocalReward = response.isNewLocalReward ? "1" : "0";
        if (isNewUser == "1") {
          if (isNewLocalReward == "1" || this.wantToAgreeEmail) {
            marketable = "1";
          } else {
            marketable = "2";
          }
        } else if (isNewLocalReward == "1") {
          marketable = "1";
        } else if (isNewLocalReward == "0" && (!this.isRegisteredReward || !this.isShowReward)) {
          marketable = "0";
        } else if (this.isRegisteredReward && this.isShowReward) {
          marketable = "1";
        }

        gioTracking("page.set", "LoginStatus", hmsrTxt + isNewUser);
        let eventName = response.isNewUser ? 'evt_Register': 'evt_Login';
        let isAll = 'nil';
        if(this.isCheckAll) {
          isAll = this.isCheckAll ? '1' : '0';
        }
        let isNewLR = 'nil'
        if (response.isNewLocalReward) {
          isNewLR = this.wantToRegisterReward ? '1': '0';
        }
        // let isMkt = "nil";
        // if (!this.isAgreeEmail) {
        //   isMkt = this.wantToAgreeEmail ? "1": "0";
        // }
        let sUrl = "nil"
        if (this.$route.query.returnUrl && this.$route.query.returnUrl.length > 0) {
          sUrl = decodeURIComponent(this.$route.query.returnUrl)
        }
        gioTracking('track', eventName, {
          // isMkt: isMkt,
          // isNewLR: isNewLR,
          isNewLRMkt: isNewLR,
          isAll: isAll,
          sUrl,
          regUrl: location.href,
          isQR:0
        })
        if (response.cmsId) {
          gioTracking('setUserId', response.cmsId);
        }
        if (response.localRewardId) {
          gioTracking('people.set', response.localRewardId);
        } else {
          gioTracking('people.set', 'nil');
        }

        // Old tracking
        gioTracking("track", "LoginStatusTracking", {
          LoginStatusTracking: hmsrTxt + isNewUser,
          IsNewLocalReward: hmsrTxt + isNewLocalReward,
          IsMarketable: marketable,
        });
        gioTracking("track", "NewLoginTracking", {
          NewLoginTracking: isNewUser,
        });

        if (window._hmt) {
          window._hmt.push(["_trackEvent", "Login", hmsrTxt, isNewUser, 1]);
        }
      } catch (e) {
        console.error(e);
      }

      let campaignId = this.$router.currentRoute.query.campaignId;
      let returnUrl = this.$router.currentRoute.query.returnUrl;
      let custom = this.$router.currentRoute.query.custom;

      if (
        campaignId &&
        campaignId.length > 0 &&
        returnUrl &&
        returnUrl.length > 0
      ) {
        if (returnUrl.indexOf("http://") >= 0 || returnUrl.indexOf("https://") >= 0) {
          returnUrl = encodeURIComponent(returnUrl);
        }

        let redirectUrl = "/Rccl.Campaign/Campaign/RedirectAuth?campaignId=" +
          campaignId +
          "&url=" +
          returnUrl +
          "&isNewUser=" +
          response.isNewUser +
          "&isNewLocalReward=" +
          response.isNewLocalReward +
          "&hpToken=" +
          response.accessToken;
        if (custom && custom.length > 0) {
          redirectUrl += "&custom=" + custom;
        }
        window.location.href = redirectUrl;

        return;
      } else if (returnUrl && returnUrl.length > 0) {
        returnUrl = decodeURIComponent(returnUrl);
        if (returnUrl.indexOf("?") > 0) {
          returnUrl += "&isNewUser=" + response.isNewUser + "&isNewLocalReward=" + response.isNewLocalReward;
        } else {
          returnUrl += "?isNewUser=" + response.isNewUser + "&isNewLocalReward=" + response.isNewLocalReward;
        }

        if (
          returnUrl.toLowerCase().indexOf("/rccl.campaign/") >= 0 ||
          returnUrl.toLowerCase().indexOf("/rccl.openapi/") >= 0 ||
          returnUrl.toLowerCase().indexOf("openbooking/bind") >= 0
        ) {
          returnUrl += "&hpToken=" + response.accessToken;
        }
      }

      if (returnUrl != "" && returnUrl != null) {
        window.location.href = returnUrl;
      } else {
        window.location.href = "/Rccl.UserCenter/CustomerInfo/Info";
      }
    },
    getSendSmsCodeText() {
      if (this.smsCodeCountDown <= 0) {
        return "发送验证码";
      } else {
        return `验证码(${this.smsCodeCountDown}s)`;
      }
    },
  },
  computed: {
    sessionKey() {
      return this.$store.state.page.sessionKey;
    },
    telephoneStyle() {
      return { "padding-left": this.telephoneLeft + "px" };
    },
    viewSource() {
      return this.$store.state.user.viewSource || '';
    }
  },
};
</script>

<style lang="less" scoped>
.page-content {
  height: calc(100vh - 50px);
  position: absolute;
  top: 50px;
  padding-bottom: 3rem;
  background: url(https://resource.rcclchina.com.cn/tui2/user_center/login.jpg)
    no-repeat;
  -webkit-background-size: 100% 100%;
  -o-background-size: 100% 100%;
  background-size: 100% 100%;
  .login-title {
    position: relative;
    margin-top: 40px;
    text-align: center;
    color: #fff;
    
    letter-spacing: 0;
    .login-title-content {
      font-size: 24px;
      margin-bottom: 10px;
    }
  }
  .loginCon {
    padding-bottom: 50px;
    .item-content {
      margin: 0 35px;
      position: relative;
      .item-inner {
        position: relative;
        width: 100%;
        .item-input-title {
          color: #333;
          font-size: 14px;
          line-height: 1;
          position: absolute;
          top: 50%;
          left: 14px;
          -webkit-transform: translateY(-50%);
          -moz-transform: translateY(-50%);
          -ms-transform: translateY(-50%);
          -o-transform: translateY(-50%);
          transform: translateY(-50%);
          .callingCode {
            max-width: 114px;
            background: url(https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-down-1.jpg)
              no-repeat right transparent;
            border: 0;
            -moz-appearance: none;
            -webkit-appearance: none;
            text-overflow: ellipsis;
            padding-right: 16px;
            overflow: hidden;
            white-space: nowrap;
          }

          .callingCode-css {
            opacity: 0;
            position: absolute;
            left: 0;
            top: -18px;
            height: 50px;
            // width: 100px;
          }
        }
        .item-input {
          margin-bottom: 0;
          input {
            background: rgba(255, 255, 255, 0.7);
            border-radius: 5px;
            border-width: 0px;
            outline: none;
            -moz-appearance: none;
            appearance: none;
            -webkit-appearance: none;
            display: block;
            width: 100%;
            height: 50px;
            text-align: left;
            padding-left: 95px;
            padding-top: 15px;
            padding-bottom: 15px;
            font-size: 14px;
            color: #333;
            line-height: 20px;
          }
          input#recommendedCode {
            padding-left: 130px;
          }
          #vcode {
            position: absolute;
            top: 13px;
            right: 10px;
          }
        }
      }
      .send_btn {
        font-size: 14px;
        color: #333333;
        letter-spacing: 0;
        position: absolute;
        right: 15px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        -o-transform: translateY(-50%);
        transform: translateY(-50%);
      }
    }

    .mt15 {
      margin-top: 15px;
    }
    .mt10 {
      margin-top: 10px;
    }
  }

  .sin_container {
    margin: 0 35px;
    font-size: 12px;
    width: calc(100% - 70px);
    .input__top {
      margin: 10px 0;
      display: flex;
      img {
        display: flex;
        width: 14px;
        height: 14px;
        cursor: pointer;
        margin-top: 2px;
      }
      & > span {
        display: block;
        width: calc(100% - 28px);
      }
    }
    .input__top img:nth-child(1) {
      display: none;
    }
    .input__top img:nth-child(2) {
      display: inline-block;
    }
    .input__top.active img:nth-child(1) {
      display: inline-block;
    }
    .input__top.active img:nth-child(2) {
      display: none;
    }
    span {
      margin-left: 4px;
      vertical-align: middle;
      color: #fff;
    }
    a {
      color: #edb000;
    }
  }

  .loginButton {
    background-image: -webkit-gradient(
      linear,
      right top,
      left top,
      from(#fad961),
      to(#febc10)
    );
    background-image: -webkit-linear-gradient(right, #fad961 0%, #febc10 100%);
    background-image: -moz-linear-gradient(right, #fad961 0%, #febc10 100%);
    background-image: -o-linear-gradient(right, #fad961 0%, #febc10 100%);
    background-image: linear-gradient(270deg, #fad961 0%, #febc10 100%);
    border-radius: 5px;
    
    font-size: 16px;
    color: #454545;
    letter-spacing: 2.5px;
    text-align: center;
    margin: 0 37.5px;
    height: 50px;
    line-height: 50px;
  }

  .login-title-tips {
    margin: 15px 37.5px 0px 37.5px;
    font-size: 12px;
    text-align: left;
    font-weight: 300;
    color: #fff;
  }
}
</style>

<style lang="less">
.loginPage {
	.verification-popup {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    overflow: hidden;
    z-index: 11;
    .verification-bg {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.7);
    }
    .verification-content {
      position: relative;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      width: 300px;
      height: 130px;
      padding-top: 24px;
      background-color: #fff;
      border-radius: 5px;
      text-align: center;
      #verificationMain {
        margin-top: 15px;
        position: relative;
        .nc_wrapper {
          width: 220px;
          margin: auto;
        }
        .nc_scale span {
          height: 34px;
        }
      }
    }
  }
}

.login-vip {
  color: #FFFFFF;
  margin: 0 37.5px -8px 18px;
  font-size: 13px;
  & .vip-title {
    font-weight: bold;
    padding: 0;
    margin: 0 0 0 28px;
  }
  & .vip-content {
    margin: 0 0 0 28px;
    padding: 0;
  }
  & .vip-content li {
    margin-top: 3px;
  }
}
</style>
